export const getWindowTitle = () => window.document.title;
export const getWindowPathname = () => window.location.pathname;
export const getWindowHash = () => window.location.hash;
export const getWindowSearch = () => window.location.search;
export const navigateToOtherWindow = path => (window.location.href = path);
export const replaceWindowState = (...params) => {
  if (window.history.replaceState) {
    window.history.replaceState(...params);
  }
};
export const pushWindowState = (...params) => {
  if (window.history.pushState) {
    window.history.pushState(...params);
  }
};

export const reloadWindowLocation = () => {
  if (typeof window !== 'undefined') {
    window.location.reload();
  }
};

export default {
  getWindowTitle,
  getWindowPathname,
  getWindowHash,
  getWindowSearch,
  replaceWindowState,
  pushWindowState,
  reloadWindowLocation,
  navigateToOtherWindow
};
